import React from 'react';
import { Link } from 'react-router-dom';
import { Sparkles } from 'lucide-react';
import { useAuth } from '../store/auth.js';

const fmt = (d) => d.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });

/** Persistent banner while the agent is on the 30-day free trial. */
export default function TrialBanner() {
  const { agent } = useAuth();
  if (agent?.subscriptionStatus !== 'trialing' || !agent?.trialEndDate) return null;
  const end = new Date(agent.trialEndDate);
  if (Number.isNaN(end.getTime())) return null;
  const price = Number(agent.monthlyPlanAmount ?? 97);

  return (
    <div
      data-testid="trial-banner"
      className="mb-4 px-4 py-2.5 rounded-lg flex flex-wrap items-center justify-between gap-3 border border-civix-purple/30 bg-gradient-to-r from-civix-purple/15 via-civix-purple/10 to-civix-cyan/10"
    >
      <div className="flex items-center gap-2 text-sm text-white/90">
        <Sparkles className="w-4 h-4 text-civix-cyan shrink-0" />
        <span>
          <strong className="text-white">30-Day Free Trial Active.</strong>{' '}
          Your trial ends on <strong className="text-civix-cyan">{fmt(end)}</strong>; renews at ${price.toFixed(0)}/mo.
        </span>
      </div>
      <Link
        to="/billing"
        className="px-3 py-1.5 rounded-md text-xs font-bold uppercase tracking-wider bg-civix-purple hover:bg-civix-purple/80 text-white transition"
      >
        Manage Subscription
      </Link>
    </div>
  );
}
